<template>
    <HeaderContent title="Package" />
    <ActionContent
        ctaText="Package"
        :filterDate="false"
        :filterModal="false"
        @action="addPackage"
        @search-query="searchData"
    />

    <DataTable
        :data="packageList"
        :header="headers"
        :custom-actions="customActions"
    >
    </DataTable>
</template>

<script setup>
import axios from "axios";
import HeaderContent from "@/components/HeaderContent.vue";
import ActionContent from "@/components/ActionContent.vue";
import DataTable from "@/components/DataTable.vue";
import { ref, onMounted, inject } from "vue";
import { useLoading } from "vue-loading-overlay";
import { useAuthStore } from "@/store/auth.js";
import { useToast } from "vue-toastification";
import { useRouter } from "vue-router";
import { formatRupiah } from "@/utils/format";

const auth = useAuthStore();
const $loading = useLoading();
const swal = inject("$swal");
const toast = useToast();
const router = useRouter();

const headers = ref([
    {
        key: "no",
        label: "No",
        thClass: "text-center px-1",
        tdClass: "text-center px-1",
    },
    {
        key: "name",
        label: "Package Name",
        sortable: true,
        thClass: "text-left",
        tdClass: "text-left",
    },
    {
        key: "duration_days",
        label: "Duration Days",
        sortable: true,
        thClass: "text-left",
        tdClass: "text-left",
    },
            {
        key: "pax",
        label: "Pax",
        sortable: true,
        thClass: "text-left",
        tdClass: "text-left",
    },
    {
        key: "price_format",
        label: "Price",
        sortable: true,
        thClass: "text-left",
        tdClass: "text-left",
    },
    {
        key: "sub_total_format",
        label: "Subtotal",
        sortable: true,
        thClass: "text-left",
        tdClass: "text-left",
    },
    { key: "action", label: "Action" },
]);
const customActions = ref([
    // {
    //     label: "Duplicate",
    //     variant: "secondary",
    //     icon: "fas fa-copy",
    //     action: (item) => {
    //         swal({
    //             title: "Confirm",
    //             text: "Are you sure to duplicate this data?",
    //             showCancelButton: true,
    //             confirmButtonText: "Yes, duplicate!",
    //             cancelButtonText: "Cancel",
    //             customClass: {
    //                 popup: "rounded",
    //                 confirmButton: "btn btn-primary me-2",
    //                 cancelButton: "btn btn-secondary",
    //             },
    //             buttonsStyling: false,
    //         }).then((confirm) => {
    //             if (confirm.value) {
    //                 duplicateData(item.uuid);
    //             } else {
    //                 swal.close();
    //             }
    //         });
    //     },
    // },
    {
        label: "Detail",
        variant: "primary",
        icon: "fas fa-info-circle",
        action: (item) => {
            if(item.uuid){
                router.push(`packages/detail/${item.uuid}`);
            }
        },
    },
    {
        label: "Edit",
        variant: "success",
        icon: "fas fa-edit",
        action: (item) => {
            if(item.uuid){
                router.push(`packages/edit/${item.uuid}`);
            }
        },
    },
    {
        label: "Delete",
        variant: "danger",
        icon: "fas fa-trash",
        action: (item) => {
            swal({
                title: "Confirm",
                text: "Are you sure to delete this data?",
                showCancelButton: true,
                confirmButtonText: "Yes, delete!",
                cancelButtonText: "Cancel",
                customClass: {
                    popup: "rounded",
                    confirmButton: "btn btn-danger me-2",
                    cancelButton: "btn btn-secondary",
                },
                buttonsStyling: false,
            }).then((confirm) => {
                if (confirm.value) {
                    deleteData(item.uuid);
                } else {
                    swal.close();
                }
            });
        },
    },
]);

const searchData = async (search) => {
    const loader = $loading.show({
        color: "#489464",
        loader: "spinner",
    });
    try {
        await getAll(search);
    } finally {
        loader.hide();
    }
};

const addPackage = () => {
    router.push('packages/add');
};

let packageList = ref([]);

const getAll = async (search = "") => {
    const response = await axios.get(
        `${process.env.VUE_APP_API_URL}/package`,
        {
            params: {
                search: search,
            },
            headers: {
                "Content-type": "application/json",
                Authorization: "Bearer " + auth._token,
            },
        }
    );

    const res = response.data;

    if (res.status) {
        packageList.value = res.data;
        packageList.value = res.data.map((i) => ({
            ...i,
            price_format: formatRupiah(i.price),
            sub_total_format: formatRupiah(i.sub_total),
        }));
    }
};

// const duplicateData = async (uuid) => {
//     if (uuid) {
//         toast.clear();
//         const loader = $loading.show({
//             color: "#009689",
//             loader: "bars",
//             zIndex: 999999,
//         });

//         try {
//             const response = await axios.post(
//                 `${process.env.VUE_APP_API_URL}/program/duplicate/${uuid}`, {},
//                 {
//                     headers: {
//                         "Content-type": "application/json",
//                         Authorization: "Bearer " + auth._token,
//                     },
//                 }
//             );

//             const res = response.data;

//             if (res.status) {
//                 toast.success(res.message);
//                 getAll();
//             }
//         } finally {
//             loader.hide();
//         }
//     }
// };

const deleteData = async (uuid) => {
    if (uuid) {
        toast.clear();
        const loader = $loading.show({
            color: "#009689",
            loader: "bars",
            zIndex: 999999,
        });

        try {
            const response = await axios.delete(
                `${process.env.VUE_APP_API_URL}/package/delete/${uuid}`,
                {
                    headers: {
                        "Content-type": "application/json",
                        Authorization: "Bearer " + auth._token,
                    },
                }
            );

            const res = response.data;

            if (res.status) {
                toast.success(res.message);
                getAll();
            }
        } finally {
            loader.hide();
        }
    }
};

onMounted(async () => {
    const loader = $loading.show({
        color: "#489464",
        loader: "spinner",
    });
    try {
        await getAll();
    } finally {
        loader.hide();
    }
});
</script>
